import { Box, Flex, Spacer } from '@chakra-ui/react';
import { Trans } from '@lingui/macro';

import useIsMobile from '../../../hooks/useIsMobile';
import { COMMON_PADDING, ROUNDED_ELEMENT_PROPS } from '../../../utils/styleUtil';
import FetchLoaderSkeleton from '../../generic/FetchLoaderSkeleton';
import CheckoutPromoCode from './CheckoutPromoCode';
import CheckoutTaxes from './CheckoutTaxes';

const CheckoutPromoTaxContainer = ({ teamId, cartOrderId, priceData, checkoutData, checkoutDataStatus }) => {
  const isMobile = useIsMobile();

  if (checkoutData == null) {
    return (
      <Box bg="brand.background_main" {...ROUNDED_ELEMENT_PROPS}>
        <FetchLoaderSkeleton
          status={checkoutDataStatus}
          skeletonsNumber={3}
          skeletonHeight={5}
          errorMessage={<Trans>Online selling is not setup, please contact an administrator.</Trans>}
        />
      </Box>
    );
  }

  return (
    <Box bg="brand.background_main" {...ROUNDED_ELEMENT_PROPS}>
      <Flex bg="brand.background_smallbox" p={COMMON_PADDING} gap="1.5rem" {...ROUNDED_ELEMENT_PROPS} flexDirection={{ base: 'column', md: 'row' }}>
        {!isMobile && (
          <>
            <CheckoutPromoCode teamId={teamId} cartOrderId={cartOrderId} />
            <Spacer />
          </>
        )}

        <CheckoutTaxes priceData={priceData} checkoutData={checkoutData} />

        {isMobile && <CheckoutPromoCode teamId={teamId} cartOrderId={cartOrderId} />}
      </Flex>
    </Box>
  );
};

export default CheckoutPromoTaxContainer;
